import React from "react";

interface InfoModalProps {
  children: React.ReactNode;
  onClose: () => void;
}

export default function InfoModal({ children, onClose }: InfoModalProps) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        background: "rgba(0,0,0,0.5)",
      }}
      onClick={onClose}
    >
      <div
        style={{
          position: "relative",
          background: "#FFFFFF",
          border: "3px solid #1A1A1A",
          borderRadius: 20,
          boxShadow: "6px 6px 0px #1A1A1A",
          padding: "28px 24px 24px",
          maxWidth: 380,
          width: "100%",
          boxSizing: "border-box",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* X close */}
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          style={{
            position: "absolute",
            top: 12,
            right: 14,
            background: "none",
            border: "none",
            fontSize: 20,
            lineHeight: 1,
            cursor: "pointer",
            color: "#888",
            padding: 4,
          }}
        >
          ✕
        </button>

        {/* Body */}
        <div
          style={{
            fontFamily: "'Nunito', sans-serif",
            fontSize: 15,
            lineHeight: 1.6,
            color: "#1A1A1A",
            marginBottom: 20,
            paddingRight: 20,
          }}
        >
          {children}
        </div>

        {/* Got it */}
        <button
          type="button"
          onClick={onClose}
          style={{
            display: "block",
            width: "100%",
            background: "#E05A3A",
            color: "#FFFFFF",
            border: "3px solid #1A1A1A",
            borderRadius: 100,
            boxShadow: "4px 4px 0px #1A1A1A",
            padding: "12px 28px",
            fontFamily: "'Fredoka', sans-serif",
            fontWeight: 700,
            fontSize: 17,
            cursor: "pointer",
            boxSizing: "border-box",
          }}
        >
          Got it
        </button>
      </div>
    </div>
  );
}
